import { register } from '@shopify/theme-sections';
import * as React from "react";
import * as ReactDOM from "react-dom";
import ProductPage from '../components/Product/ProductPage';
import Swiper from 'swiper/js/swiper.js';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/src/css/main.scss';
import '../styles/components/photoswipe.scss';
import 'swiper/src/swiper.scss';

let mainGallery = null;
const container = [];
function createMainGallery() {
    try {
        return new Swiper('.product__main-slider', {
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            }
        });
    } catch(error) {
        console.error(error);
        return false;
    }
}
function onClickThumbnail(thumbnail) {
    const index = thumbnail.getAttribute('data-index');
    if(mainGallery) {
        const current = document.querySelector('.product__thumbnail--active');
        if (current) {
            current.classList.remove('product__thumbnail--active');
        }
        thumbnail.classList.add('product__thumbnail--active');
        mainGallery.slideTo(index);
    }
}
function showPopup(index) {
    const pswp = document.getElementById('pswp');
    const options = {
        index: index,
        bgOpacity: 1,
        timeToIdle: 4000,
        shareEl: false,
        showHideOpacity: true,
        barsSize: {top:100, bottom:100},
        getThumbBoundsFn: function(index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            var thumbnail = container[index].el,
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();

            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
    }
    const popupImages = new PhotoSwipe(pswp, PhotoSwipeUI_Default, container, options);
    popupImages.init();
    popupImages.listen('afterChange', function() {
        //Select the current slide
        const index = popupImages.getCurrentIndex();
        if (mainGallery) {
            mainGallery.slideTo(index,0,false);
        }
        const activeThumbnail = document.querySelector('.product__thumbnail--active');
        if (activeThumbnail) {
            activeThumbnail.classList.remove('product__thumbnail--active');
            const current = document.querySelector(`.product__thumbnail[data-index="${index}"]`);
            if (current) {
                current.classList.add('product__thumbnail--active');
            }
        }
    });
}
register('product', {
    onLoad() {
        //Add slider when there is more than 1 image
        const totalSlides = document.querySelectorAll('.product__main-slider .swiper-slide');
        if (totalSlides.length > 1) {
            mainGallery = createMainGallery();
            if (mainGallery) {
                const thumbnails = document.querySelectorAll('.product__thumbnail');
                thumbnails.forEach( function(thumbnail) {
                    thumbnail.onclick = onClickThumbnail.bind(this, thumbnail);
                })
            }
        }
        totalSlides.forEach( function(slide, index) {
           const image = slide.querySelector('img');
           if (image) {
                const src = image.getAttribute('data-src');
                let msrc = null;
                if (src) {
                    msrc = src.replace('{width}',2000);
                }
                const item = {
                    src: msrc ? msrc : image.getAttribute('src'),
                    msrc: image.getAttribute('src'),
                    w: 2000,
                    h: 2000,
                    title: '',
                    el: image
                };
                container.push(item);
                image.onclick = showPopup.bind(this, index);
           }
        });
        ReactDOM.render(React.createElement(ProductPage, {
            product: window.product,
            customFields: window.customFields,
            colourVariations: window.colourVariations,
            productSectionSettings: window.productSectionSettings,
            theme: window.theme
        }), document.getElementById('product-dom'));
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
      this.$container.off(this.namespace);
    },
  });

